/*
Inspiration:
- https://markus.oberlehner.net/blog/implementing-a-simple-middleware-with-vue-router/
- https://blog.logrocket.com/vue-middleware-pipelines/
 */
export const middlewarePipeline = (context, middleware, index) => {
  const nextMiddleware = middleware[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return () => {
    const nextPipeline = middlewarePipeline(
      context, middleware, index + 1
    );

    nextMiddleware({
      ...context,
      next: nextPipeline,
      // https://github.com/Dotunj/vue-middleware-pipelines/issues/1 (Decided to use 'redirect' instead of 'nextVue')
      redirect: context.next,
    });
  };
};
